<template>
  <div>
    <v-layout column v-if="shopLoad" align-center>
      <!-- <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular> -->
      <progress-q></progress-q>
    </v-layout>
    <v-layout row wrap v-if="!shopLoad">
      <input
        type="file"
        ref="files"
        @change="selectedFiles($event.target.files)"
        multiple="true"
        accept="image/*"
        v-show="false"
      >
      <v-flex xs12>
        <v-progress-linear value="updateProgressValue" v-show="isLoading" :active="isLoading"></v-progress-linear>
      </v-flex>
      <v-flex xs12 sm12 md4 lg3>
        <v-card class="elevation-3 dash-card">
          <v-toolbar class="q-orange-bk" dark>
            <v-toolbar-title>{{getString('Lista gallerie')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon v-show="selected.idGallery > 0" @click="renewDialog = true">
              <v-icon>create</v-icon>
            </v-btn>
            <v-btn icon v-show="selected.idGallery > 0" @click="deleteDialog = true">
              <v-icon>remove</v-icon>
            </v-btn>
            <v-btn icon @click="newDialog = true">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-list two-line v-if="galleries.length > 0">
              <template v-for="(item, index) in galleries">
                <v-list-tile
                  :class="{ 'q-orange-bk': item.idGallery === selected.idGallery, 'q-text-whitesmoke': item.idGallery === selected.idGallery }"
                  :key="item.idGallery"
                  @click="setGallery(index)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.title"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
            <h3 v-else>{{getString("Nessuna galleria presente, aggiungine una premendo sul +")}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md8 lg9>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk" dark>
            <v-toolbar-title>{{selected === null ? getString('Scegli una galleria') : selected.title}}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container grid-list-sm fluid>
            <v-progress-linear v-show="deleting" indeterminate color="red lighten-4"></v-progress-linear>
            <v-layout row wrap>
              <v-flex
                v-for="(item, index) in selected.photos"
                :key="item.idPhoto"
                xs6
                sm4
                md3
                lg2
                d-flex
              >
                <v-card v-if="index < selected.photos.length - 1" tile class="d-flex elevation-1">
                  <v-img
                    :src="item.link"
                    :lazy-src="lazySrc"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                      class="img-delete"
                      @click="deleteImage(item,index)"
                    >
                      <v-icon size="50" color="white">delete_forever</v-icon>
                    </v-layout>
                  </v-img>
                </v-card>
                <v-card v-if="index == selected.photos.length - 1" tile class="d-flex elevation-1">
                  <v-img aspect-ratio="1" class="grey lighten-2">
                    <v-layout fill-height aligh-center justify-center>
                      <v-icon size="50" style="cursor:pointer" @click="addImages">add</v-icon>
                    </v-layout>
                  </v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="newDialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">{{getString('Nuova galleria')}}</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <label>{{getString('Nome')}}</label>
              <v-text-field
                v-model="newName"
                solo
                counter="20"
                :label="getString('Nome galleria')"
                :rules="notEmpty"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn class="q-orange" flat @click.native="resetNew">{{getString('Chiudi')}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="q-orange" flat @click.native="setNewGallery">{{getString('Aggiungi')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="renewDialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">{{getString('Rinomina galleria')}}</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <label>{{getString('Nome')}}</label>
              <v-text-field
                v-model="newName"
                solo
                counter="20"
                :label="getString('Nome galleria')"
                :rules="notEmpty"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn class="q-orange" flat @click.native="resetRenew">{{getString('Chiudi')}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="q-orange" flat @click.native="setGalleryName">{{getString('Salva')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">{{getString('Cancella galleria galleria')}}</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h3 style="color:red">{{getString('Attenzione!')}}</h3>
              <p>{{getString('Cancellando la galleria cancellerai anche tutte le foto associate!')}}</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn class="q-orange" flat @click.native="deleteDialog = false">{{getString('Annulla')}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="q-orange" flat @click.native="deleteGall">{{getString('Conferma')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Utils from "../../../utils.js";
import ajax from "../../../ajax.js";
import ProgressQ from "../ProgressQ";
import ImageCompressor from "image-compressor.js";
var ut = new Utils();
export default {
  name: "ShopGalleries",
  props: ["shopID", "tab"],
  components: {
    ProgressQ
  },
  mounted: function() {
    this.getGall();
  },
  computed: {
    lazySrc: function() {
      return ajax.baseUrl() + "/../../../../static/img/shopdefault.png";
    },
    notEmpty: function() {
      return [v => v.length > 0 || this.getString("Campo vuoto")];
    }
  },
  data: () => {
    return {
      h: null,
      show: false,
      hidden: false,
      deleting: false,
      image: null,
      updateProgressValue: 0,
      shopLoad: false,
      isLoading: false,
      newDialog: false,
      deleteDialog: false,
      renewDialog: false,
      newName: "",
      galleries: [],
      selected: {
        idGallery: 0,
        photos: [],
        title: ""
      }
    };
  },
  watch: {
    shopID: function() {
      if (this.shopID > 0) {
        this.getGall();
      }
    }
  },
  methods: {
    deleteGall: function() {
      this.deleteDialog = false;
      let self = this;
      if (self.shopID > 0) {
        self.deleting = true;
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/galleries/gallery/" +
              self.selected.idGallery +
              "/delete",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.deleting = false;
            self.$emit(
              "siteAlertSuccess",
              self.getString("Galleria eliminata")
            );
            self.getGall();
            self.selected = {
              idGallery: 0,
              photos: [],
              title: ""
            };
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.deleting = false;
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    deleteImage: function(item, index) {
      let self = this;
      if (self.shopID > 0) {
        self.deleting = true;
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/galleries/gallery/" +
              item.referenceGalleries +
              "/images/image/" +
              item.idPhoto +
              "/delete",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.selected.photos.splice(index, 1);
            self.deleting = false;
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.deleting = false;
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    normalizeLink: function(link) {
      return ajax.baseUrl() + link;
    },
    selectedFiles: function(flist) {
      if (this.$refs.files.files.length > 0) {
        let self = this;
        this.isLoading = true;
        var count = 0;
        var data = new FormData();
        for (let i = 0; i < flist.length; i++) {
          new ImageCompressor(flist[i], {
            quality: 0.7,
            success(result) {
              if (result.size < 2000000) {
                data.append("files[" + count - 1 + "]", result, result.name);
              } else {
                self.$emit(
                  "siteAlert",
                  self.getString(
                    "Un'immagine selezionata è superiore alla dimensione massima di 2MB"
                  )
                );
              }
              count++;
              if (count === flist.length) {
                ajax.axios
                  .post(
                    ajax.baseUrl() +
                      "/admin/shops/shop/" +
                      self.shopID +
                      "/galleries/gallery/" +
                      self.selected.idGallery +
                      "/new/images",
                    data,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + self.$store.getters.token
                      },
                      onUploadProgress: function(progressEvent) {
                        let p = parseInt(
                          Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                          )
                        );
                        self.updateProgressValue = p;
                      }.bind(this),
                      withCredentials: true
                    }
                  )
                  .then(function(response) {
                    ajax.validateToken(response.headers, self.$store);
                    self.getGall();
                    self.isLoading = false;
                    self.updateProgressValue = 0;
                  })
                  .catch(function(error) {
                    var auth = ajax.checkAuth(error, self.$store, self.$router);
                    self.isLoading = false;
                    self.updateProgressValue = 0;
                    self.$emit(
                      "siteAlert",
                      auth
                        ? self.getString("Non hai l'autorizzazione")
                        : error.response.data.errorMessage
                    );
                  });
              }
            },
            error(e) {
              self.$emit(
                "siteAlert",
                self.getString("Il file selezionato non è un'immagine")
              );
              self.isLoading = false;
            }
          });
        }
      }
    },
    addImages: function() {
      this.$refs.files.click();
    },
    resetNew: function() {
      this.newName = "";
      this.newDialog = false;
    },
    resetRenew: function() {
      this.newName = "";
      this.renewDialog = false;
    },
    setGalleryName: function() {
      let self = this;
      if (
        self.shopID > 0 &&
        this.newName.length > 3 &&
        this.newName.length < 21
      ) {
        ajax.axios
          .put(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/galleries/gallery/" +
              self.selected.idGallery,
            {
              name: self.newName
            },
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit("siteAlertSuccess", response.data.data);
            self.selected.title = self.newName;
            self.resetRenew();
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    setNewGallery: function() {
      let self = this;
      if (
        self.shopID > 0 &&
        this.newName.length > 3 &&
        this.newName.length < 21
      ) {
        ajax.axios
          .post(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/galleries/new",
            {
              title: self.newName
            },
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.galleries = response.data.data;
            self.galleries.forEach(e => {
              e.photos.push({});
            });
            self.resetNew();
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    setGallery: function(i) {
      this.selected = this.galleries[i];
    },
    getGall: function() {
      let self = this;
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/galleries",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.galleries = response.data.data;
            self.galleries.forEach(e => {
              e.photos.push({});
            });
            if (self.galleries.length > 0) self.selected = self.galleries[0];
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    }
  }
};
</script>

<style scoped>
.img-delete {
  color: whitesmoke;
  background: red;
  opacity: 0;
  transition: opacity 0.2s linear;
  -o-transition: opacity 0.2s linear;
  -moz-transition: opacity 0.2s linear;
  -webkit-transition: opacity 0.2s linear;
  -ms-transition: opacity 0.2s linear;
}
.img-delete:hover {
  opacity: 0.6;
  cursor: pointer;
}
.save-alert {
  animation-name: saveAlertAnimation !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}

@keyframes saveAlertAnimation {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: bisque;
  }
  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopGalleries.vue